import { Tooltip } from '@design/components/tooltip/Tooltip';
import { checkCellValueStyle, NumericalCellValueStyle } from '@helpers';
import clsx from 'clsx';

import { BAR_HEIGHT, CHART_WIDTH, margin } from '../constants';
import styles from './HorizontalLabels.module.scss';

interface HorizontalLabelsProps {
  value: number;
  leftLabel: string;
  rightLabel: string;
  tooltipLabel: string;
  paddingLeft?: number;
  yPosition: number;
  prefix: string;
}

export const HorizontalLabels = ({
  value,
  leftLabel,
  rightLabel,
  tooltipLabel,
  paddingLeft = 0,
  yPosition,
  prefix,
}: HorizontalLabelsProps) => {
  const numericalStyle = checkCellValueStyle(value);
  const rightLabelText =
    value > 0 && prefix ? `${prefix}${rightLabel}` : rightLabel;
  return (
    <g
      transform={`translate(0, ${BAR_HEIGHT / 2})`}
      data-testid="left-right-labels"
    >
      <text
        className={clsx(styles.medianText, {
          [styles.medianTextPositive]:
            numericalStyle === NumericalCellValueStyle.Positive,
          [styles.medianTextNegative]:
            numericalStyle === NumericalCellValueStyle.Negative,
          [styles.medianTextNeutral]:
            numericalStyle === NumericalCellValueStyle.Neutral,
        })}
        x={CHART_WIDTH - margin.right}
        y={yPosition}
        dy="0.35em"
      >
        {rightLabelText}
      </text>
      <Tooltip disabled={!tooltipLabel} label={tooltipLabel} inPortal>
        <text
          className={styles.labelText}
          x={margin.left + paddingLeft}
          y={yPosition}
          dy="0.35em"
        >
          {/* TODO: https://app.clickup.com/t/8693518xt include portfolio image + ticker  */}
          {leftLabel}
        </text>
      </Tooltip>
    </g>
  );
};
